<template>
  <div>
    <view-table
        ref="viewTable"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        module="basic"
        url="productApplications"
        @addOrEdit="addEditHandle"
        @select="selectHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
        <template slot="otherBtn">
        <el-button
            type="primary"
            :loading="exportLoading"
            @click="exportExcel()">
          导出
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.no" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="名称">
            <el-input v-model.trim="filter.productName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.statusName" placeholder="请选择" clearable>
              <el-option label="草稿" value="草稿"/>
              <el-option label="业务经理审核" value="业务经理审核"/>
              <el-option label="总经理审核" value="总经理审核"/>
              <el-option label="采购审核" value="采购审核"/>
              <el-option label="技术经理审核" value="技术经理审核"/>
              <el-option label="项目工程师审核" value="项目工程师审核"/>
              <el-option label="技术经理复审" value="技术经理复审"/>
              <el-option label="业务审核" value="业务审核"/>
              <el-option label="总经理复审" value="总经理复审"/>
              <el-option label="通过" value="通过"/>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类型">
            <el-select v-model="filter.productCategory" placeholder="请选择" clearable>
              <el-option label="滤波器" :value="10"/>
              <el-option label="变压器" :value="20"/>
              <el-option label="解谐电抗器" :value="30"/>
              <el-option label="电抗器" :value="40"/>
              <el-option label="电阻" :value="50"/>
              <el-option label="高频电感" :value="60"/>
              <el-option label="高压" :value="70"/>
            </el-select>
          </el-form-item>
          <el-form-item label="客户">
            <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="BOM编号">
            <el-input v-model.trim="filter.bomNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="操作卡编号">
            <el-input v-model.trim="filter.esopNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="产品规格">
            <el-input v-model.trim="filter.specificationType" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select v-model="filter.orderType" clearable>
              <el-option v-for="item in orderTypes" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="项目类型">
            <el-select v-model="filter.applicationType" clearable>
              <el-option v-for="item in applicationTypes" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'createTimeBegin', 'createTimeEnd')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.addAuth"
            type="primary"
            :disabled="scope.row.status !== 0"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
      </template>
    </view-table>
    <!-- 编辑 -->
    <production-application-edit ref="applicationEdit" @save-success="loadData(1)"/>
    <workflow-detail ref="workflowDetail"/>
  </div>
</template>

<script>
import ViewTable from "@/components/ViewTable.vue";
import ProductionApplicationEdit from "@/views/fm/ProductionApplication/ProductionApplicationEdit";
import constant from "@/util/constant";
import workflowDetail from "@/views/workFlow/WorkflowDetail.vue";

export default {
  name: "ProductApplicationList",
  components: {
    ViewTable,
    ProductionApplicationEdit,
    workflowDetail,
  },
  data() {
    return {
      limits: {
        addAuth: this.$auth(238),
        editAuth: this.$auth(239),
        delAuth: this.$auth(240),
      },
      importLoading: false,
      exportLoading:false,
      mainBoxHeight: 0,
      data: [],
      createDateRange: [],
      filterText: "",
      orderTypes: constant.toSelect(constant.productOrderType),
      applicationTypes: constant.toSelect(constant.productApplicationType),
      filter: {
        no: "",
        statusName: "",
        customerName: "",
        materialNo: "",
        specification: "",
        bomNo: "",
        esopNo: "",
        applicationType: "",
        orderType: "",
        customerNo: "",
        productName: "",
        specificationType: "",
        productCategory: "",
        createTimeBegin: "",
        createTimeEnd: "",
        creatorName: "",
      },
      columnsProperty: [
        {
          key: "no",
          align: "center",
          render: (h, params) => {
            return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.applicationEdit.open(params.row.pkId, true);
                    },
                  },
                },
                params.row.no,
            );
          },
        },
        {
          key: "statusName",
          align: "center",
          render: (h, params) => {
            return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.workflowDetail.open(params.row.pkId, 13);
                    },
                  },
                },
                params.row.statusName,
            );
          },
        },
        {
          key: "action",
          align: "center",
          width: 200,
          slot: "action",
          fixed: "right",
        },
      ],
      selection: [],
    };
  },

  watch: {
    "filter.createTimeBegin": {
      handler(newVal) {
        if (newVal) {
          this.createDateRange = [];
          this.createDateRange.push(this.filter.createTimeBegin);
          this.createDateRange.push(this.filter.createTimeEnd);
        }
      },
    },
  },

  methods: {
    addEditHandle(row) {
      if (row) {
        this.$refs.applicationEdit.open(row.pkId, false);
      } else {
        this.$refs.applicationEdit.open(0, false);
      }
    },
    dateRangeChange(timeRange, timeStart, timeEnd) {
      if (this[timeRange]) {
        this.filter[timeStart] = this[timeRange][0];
        this.filter[timeEnd] = this[timeRange][1];
      } else {
        this.filter[timeStart] = "";
        this.filter[timeEnd] = "";
      }
    },
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },
    // 提交
    submitHandle(row) {
      this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
        this.$http.post("basic", `productApplications/submit/${row.pkId}`).then((resp) => {
          if (resp.success) {
            this.$message.success("提交成功");
            this.loadData(1);
          }
        });
      });
    },
    // 删除(单删、多删)
    deleteHandle(row) {
      let ids = [];
      ids.push(row.pkId);
      this.$http.delete("basic", "productApplications", ids).then((res) => {
        if (res.success) {
          this.loadData(1);
          this.$message.success("删除成功");
        }
      });
    },

    // checkBox
    selectHandle(selection) {
      this.selection = selection;
    },

    exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","productApplications/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },

    otherAuth(row) {
      if (row.status === 0 || row.status === 5) {
        return {
          editAuth: false,
          delAuth: false,
        };
      } else {
        return {
          editAuth: true,
          delAuth: true,
        };
      }
    },

  },
};
</script>
<style scoped>
</style>

<style>
</style>
